export default __webpack_public_path__ + "static/media/x.68f5632a.png";